import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Table } from 'reactstrap';
import { UgoMaterialPageVM } from "./UGOMaterialPageVM";
import './UGOMaterialPage.scss';
import { UgoPipelineMaterialTypeResponseDTO } from "cd-eft/_codegen_/openapi-generator/eft-set";

const UgoMaterialComponent = () => {
  const vm = useRef(new UgoMaterialPageVM()).current;

  const Cols = [
    { name: "material", title: "Material" },
    { name: "minSize", title: "Min Size" },
    { name: "maxSize", title: "Max Size" },
    { name: "pressurizable", title: "Pressurizable" },
  ];

  return (
    <div className='pipeline-materials-container'>
      <div className='materials-container-content'>
        <h1 tabIndex={0}>Underground Outlet (UGO) Material List</h1>
        <Table className="set-table materials-table">
          <thead className="table-header">
            <tr>
              {Cols.map((e, index) => (
                <th key={'key-ugoSummary-title' + index} className={e.name === 'warnings' ? 'tooltip-header' : ''}>
                  <span>
                    {e.title}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          {vm.pipelineMaterials.length > 0 ? (
            <tbody>
              {vm.pipelineMaterials.map((el: UgoPipelineMaterialTypeResponseDTO, index: number) => (
                <tr key={'key-material-' + index}>
                  <td>{el.pipelineMaterialName}</td>
                  <td>{el.minSize}</td>
                  <td>{el.maxSize}</td>
                  <td>{el.canPressurizable ? 'Y' : 'N'}</td>
                </tr>
              ))}
            </tbody>
          ) : null}
        </Table>
      </div>
    </div>
  )
};

export const UgoMaterialList = observer(UgoMaterialComponent);